import React, { useEffect, useRef } from "react";
import LanguageToggle from "./LanguageToggle";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Menu } from "lucide-react";
import { setSideBarOpen } from "store/slices/commonSlice";
import { isDesktop } from "utils/utils";

const AdminHeader = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { authUserDetails } = useSelector((state) => state.Auth);
  const { isSideBarOpen } = useSelector((state) => state.CommonActions);
  const { name } = authUserDetails || {};

  useEffect(() => {
    if (!isSideBarOpen) return;

    const handleOutsideClick = (e) => {
      const sidebar = document.getElementById("sidebar_menu"); // adjust to your sidebar's actual id/class
      const menuButton = document.getElementById("menu-toggle-btn");

      if (
        sidebar &&
        !sidebar.contains(e.target) &&
        menuButton &&
        !menuButton.contains(e.target)
      ) {
        dispatch(setSideBarOpen(false));
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [isSideBarOpen, dispatch]);

  useEffect(() => {
    if (!isDesktop) {
      dispatch(setSideBarOpen(false)); // automatically hide when mobile screen
    }
  }, [isDesktop]);

  return (
    <header id="page-topbar">
      <div className="g_between">
        <div
          className={`d-flex gap-3 align-items-center header_item ${
            !isSideBarOpen ? "sidebar-collapsed" : ""
          }`}
        >
          <button
            id="menu-toggle-btn"
            type="button"
            className="border-0 collapse_button"
            onClick={() => dispatch(setSideBarOpen(!isSideBarOpen))}
          >
            <Menu size={24} />
          </button>

          <h6 className="title">
            {t("Hello")} {name}
          </h6>
        </div>
        {!isSideBarOpen && <LanguageToggle />}
      </div>
    </header>
  );
};

export default AdminHeader;
